import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const HARDCODED = [
	{
		title: "Madrasah cerdas Mandiri",
		desc: "Transformasi pengelolaan madrasah secara mandiri dan digital untuk masa depan yang lebih baik.",
		img: "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?q=80&w=2070&auto=format&fit=crop",
	},
	{
		title: "Presensi Online",
		desc: "Sistem absensi digital yang akurat dan transparan untuk guru, siswa, serta tenaga kependidikan.",
		img: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?q=80&w=2070&auto=format&fit=crop",
	},
	{
		title: "Dashboard",
		desc: "Pusat informasi dan kendali digital yang menyajikan data secara komprehensif dalam satu tampilan.",
		img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2015&auto=format&fit=crop",
	},
];

function FiturJMD() {
	const [isVisible, setIsVisible] = useState(false);
	const [items, setItems] = useState(HARDCODED);
	const [sectionTitle, setSectionTitle] = useState("Fitur");
	const [sectionSubtitle, setSectionSubtitle] = useState(
		"Jogja Madrasah Digital"
	);
	const sectionRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) setIsVisible(true);
			},
			{ threshold: 0.15 }
		);
		if (sectionRef.current) observer.observe(sectionRef.current);
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		axios
			.get("/api_w/features", {
				headers: { db_name: process.env.REACT_APP_DB_NAME },
			})
			.then((res) => {
				const items = res.data.data;
				if (items?.length) {
					const mapped = items.map((f) => ({
						title: f.title,
						desc: f.description,
						img: f.image_url || "",
						icon: f.icon || "",
					}));
					setItems(mapped);
				}
			})
			.catch(() => {});
	}, []);

	return (
		<section aria-label="Fitur JMD" ref={sectionRef} className="py-20 px-4 md:px-20 bg-gray-50">
			<div className="max-w-8xl mx-auto">
				<div className="mb-16">
					<h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
						{sectionTitle}
						<br />
						<span className="text-green-700">{sectionSubtitle}</span>
					</h2>
					<p className="text-gray-500 max-w-2xl text-sm md:text-base">
						Platform ini menghadirkan berbagai fitur unggulan untuk mempermudah
						ekosistem pendidikan madrasah secara menyeluruh.
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					{items.map((feature, idx) => (
						<div
							key={idx}
							className={`group transition-all duration-700 ${
								isVisible ? "animate-fade-in-up opacity-100" : "opacity-0"
							}`}
							style={{ animationDelay: `${idx * 0.2}s` }}
						>
							<div className="relative rounded-3xl overflow-hidden shadow-lg aspect-[4/3] mb-6">
								<img
									src={feature.img || HARDCODED[idx % HARDCODED.length]?.img}
									alt={feature.title}
									className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
									onError={(e) => { e.target.src = "https://placehold.co/400x300/006045/white?text=Fitur"; e.target.onerror = null; }}
								/>
								<div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-500" />
								<div className="absolute inset-0 flex items-center justify-center">
									<div className="w-16 h-16 rounded-full bg-green-600/90 flex items-center justify-center text-white shadow-xl transform group-hover:scale-110 transition-transform duration-300">
										<svg
											className="w-8 h-8 ml-1"
											fill="currentColor"
											viewBox="0 0 24 24"
										>
											<path d="M8 5v14l11-7z" />
										</svg>
									</div>
								</div>
							</div>

							<h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-green-700 transition-colors duration-300">
								{feature.title}
							</h3>
							<p className="text-gray-500 text-sm leading-relaxed">
								{feature.desc}
							</p>
						</div>
					))}
				</div>

				<div className="mt-16 text-center">
					<Link
						to="/feature"
						className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold px-10 py-3.5 rounded-full shadow-lg shadow-green-600/20 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
					>
						Lihat Selengkapnya
					</Link>
				</div>
			</div>
		</section>
	);
}

export default FiturJMD;
